import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/shared/Header';
import ProtectedRoute from './components/shared/ProtectedRoute';
import Login from './pages/Login';
import Overview from './pages/Overview';
import ClientDetail from './pages/ClientDetail';
import Agents from './pages/Agents';
import Calendar from './pages/Calendar';
import Chat from './pages/Chat';
import UserManagement from './pages/admin/UserManagement';
import UserPermissions from './pages/admin/UserPermissions';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/chat"
        element={
          <ProtectedRoute excludeRole="cliente">
            <div className="app">
              <Header />
              <Chat />
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <div className="app">
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Overview />} />
                  <Route path="/client/:id" element={<ClientDetail />} />
                  <Route path="/agents" element={<ProtectedRoute excludeRole="cliente"><Agents /></ProtectedRoute>} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route
                    path="/admin/users"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <UserManagement />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/permissions"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <UserPermissions />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </main>
            </div>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
